import Box from "@mui/material/Box";
import { styled } from "@mui/material/styles";

import { getFormatMedia } from "~/theme/utils";

import { NEARBY_STORES_CLASSES } from "./constants";

export const NearbyStoresContainer = styled(Box)(({ theme }) => {
  const { BREAKPOINT_TABLET, BREAKPOINT_DESKTOP } = getFormatMedia(theme);

  return {
    marginBottom: theme.spacing(7),
    [BREAKPOINT_TABLET]: {
      marginBottom: theme.spacing(9),
    },
    [BREAKPOINT_DESKTOP]: {
      marginBottom: theme.spacing(16),
    },

    [`& .${NEARBY_STORES_CLASSES.title}`]: {
      marginBottom: theme.spacing(2),
      ...theme.typography.h5,
      [BREAKPOINT_TABLET]: {
        marginBottom: theme.spacing(4),
        ...theme.typography.h4,
      },
      [BREAKPOINT_DESKTOP]: {
        ...theme.typography.h3,
      },
    },

    [`& .${NEARBY_STORES_CLASSES.cards}`]: {
      justifyContent: "center",
    },

    [`& .${NEARBY_STORES_CLASSES.hideOnMobile}`]: {
      display: "none",
      [BREAKPOINT_DESKTOP]: {
        display: "flex",
      },
    },
  };
});
